// Components
import Hero from "../components/layout/Hero";
import Prices from "../components/pricelist/Prices";
import PaymentMethods from "../components/pricelist/PaymentMethods";

// Assets
import "../assets/styles/priceList.css";
import heroImg from "../assets/images/pricelist/hero.jpg";

// Hooks
import { useTranslation } from "../hooks/useTranslation";
import SpecialDiscount from "../components/pricelist/SpecialDiscount";


export default function Pricelist(params) {
    const t = useTranslation();

    return (
        <section id="priceListSection" >
            <Hero
                bgImage={heroImg}
                title={t("pricelist.title")}
            />

            <Prices motionOrder={0} />
            <SpecialDiscount motionOrder={1} />
            <PaymentMethods motionOrder={2} />
        </section>
    )
}